// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper_pUpIs","disableEditing":"disableEditing_15FGa","spreadWrapper":"spreadWrapper_fpv8F","spread":"spread_yzeHB","fold":"fold_1fFVr","label":"label_gZmlY"};


//////////////////
// WEBPACK FOOTER
// ./app/components/spread/styles.scss
// module id = 507
// module chunks = 1